import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "mdb-react-ui-kit/dist/css/mdb.min.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import TopHeading from './components/TopHeading';
import MiddleContent from './components/MiddleContent';
import OurServices from './components/OurServices';
import Projects from './components/Projects';
import Developer from './components/Developer';
import Footer from './components/Footer';

function App() {
  return (
    <div>
    <TopHeading/>
    <MiddleContent/>
    <OurServices/>
    <Projects/>
    <Developer/>
    <Footer/>
    </div>
  );
}

export default App;
